
    import { BaseMark } from '../BaseMark.js';
    import { CssVars } from '../../../util/CssVars.js';

    const glyphname = 'stavrosAbove';
    const args = {};

    export class StavrosAbove extends BaseMark {
    constructor() {
        super(glyphname, args);
    }
    }
            